import { useMemo, useState } from "react";
import { authService } from "../../../api/services/authService";
import { tokenService } from "../../../api/utils/tokenService";
import { useNavigate } from "react-router-dom";
export type SignupMethod = "email" | "phone";

export function useSignupViewModel() {
  const [method, setMethod] = useState<SignupMethod>("email");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [showHowItWorks, setShowHowItWorks] = useState(false);
  const [maskedDestination, setMaskedDestination] = useState("");
  const navigate = useNavigate();
  const isValidEmail = useMemo(
    () =>
      /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim()),
    [email]
  );

  const isValidPhone = useMemo(
    () => /^[0-9]{10}$/.test(phone.trim()),
    [phone]
  );

  const openHowItWorks = () => setShowHowItWorks(true);

  const closeHowItWorks = () => setShowHowItWorks(false);
  const [step, setStep] = useState<"signup" | "otp">("signup");
  const goToOtp = async () => {
    const response = await authService.sendOtp({
      identifier:
        method === "email"
          ? email
          : phone,
      otpChannel: "WEB",
      deviceToken:
        localStorage.getItem("deviceToken") ??
        undefined,
    });

    if (!response.otpRequired && response.data) {
      tokenService.setTokens({
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken,
      });

      if (response.data.deviceToken) {
        localStorage.setItem(
          "deviceToken",
          response.data.deviceToken
        );
      }

      localStorage.setItem(
        "partner",
        JSON.stringify(response.data.partner)
      );

      navigate("/account-type"); // or dashboard
      return;
    }

    setMaskedDestination(response.maskedDestination);
    setStep("otp");
  };
  return {
    method,
    setMethod,

    email,
    setEmail,

    phone,
    setPhone,

    isValidEmail,
    isValidPhone,

    showHowItWorks,
    openHowItWorks,
    closeHowItWorks,

    step,
    setStep,

    goToOtp,

    maskedDestination,
  };
}